(function () {
  document.querySelectorAll('img[data-ed-blur]').forEach((img) => {
    img.style.opacity = '0';
    img.style.transition = 'opacity 560ms cubic-bezier(0.22, 1, 0.36, 1), filter 560ms cubic-bezier(0.22, 1, 0.36, 1)';
    img.style.filter = 'blur(12px) saturate(0.8)';
    const reveal = () => { img.style.opacity = '1'; img.style.filter = 'none'; };
    if (img.complete) reveal();
    else img.addEventListener('load', reveal, { once: true });
  });
})();
